/**
 * ARCHIVO GENERADO — no editar.
 *
 * Ocho tonos en ORDEN FIJO, validados para daltonismo en los dos modos sobre
 * las superficies reales del sistema. El orden es el mecanismo de seguridad:
 * las comprobaciones se hacen sobre pares adyacentes, así que reordenar
 * invalida la medición.
 */

import { useTheme } from "@mui/material/styles";

const SERIES_LIGHT = [
  "#2A78D6",
  "#EB6834",
  "#1BAF7A",
  "#EDA100",
  "#E87BA4",
  "#008300",
  "#4A3AA7",
  "#E34948",
];
const SERIES_DARK = [
  "#3987E5",
  "#D95926",
  "#199E70",
  "#C98500",
  "#D55181",
  "#008300",
  "#9085E9",
  "#E66767",
];
const SEQUENTIAL_LIGHT = ["#CDE2FB", "#86B6EF", "#3987E5", "#1C5CAB"];
const SEQUENTIAL_DARK = ["#1C5CAB", "#3987E5", "#86B6EF", "#CDE2FB"];

/** Nunca ciclar: pasadas las ocho, agrupar el resto en "otros". */
export const MAX_SERIES = SERIES_LIGHT.length;

export function useChartPalette() {
  const mode = useTheme().palette.mode;
  const series = mode === "dark" ? SERIES_DARK : SERIES_LIGHT;
  const sequential = mode === "dark" ? SEQUENTIAL_DARK : SEQUENTIAL_LIGHT;

  return {
    series,
    sequential,
    /**
     * El color de la serie N. Devuelve el gris de "otros" pasadas las ocho, en
     * vez de reciclar un tono: dos series pintadas igual hacen que el grafico
     * afirme algo falso sobre los datos, que es peor que verse mal.
     */
    color: (index: number) =>
      series[index] ?? (mode === "dark" ? "#6B7280" : "#9CA3AF"),
    max: MAX_SERIES,
  };
}
